import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=8055549c&scoped=true"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"
import style0 from "./structure.vue?vue&type=style&index=0&id=8055549c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8055549c",
  null
  
)

export default component.exports